/**
 * @flow
 * @relayHash 3aa673bb98e3b1a5ef0494b148e2513c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteUserSavedFilterInput = {|
  id: string
|};
export type DeleteUserSavedFilterMutationVariables = {|
  input: DeleteUserSavedFilterInput
|};
export type DeleteUserSavedFilterMutationResponse = {|
  +deleteUserSavedFilter: {|
    +deletedId: string
  |}
|};
export type DeleteUserSavedFilterMutation = {|
  variables: DeleteUserSavedFilterMutationVariables,
  response: DeleteUserSavedFilterMutationResponse,
|};
*/


/*
mutation DeleteUserSavedFilterMutation(
  $input: DeleteUserSavedFilterInput!
) {
  deleteUserSavedFilter(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteUserSavedFilterInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteUserSavedFilter",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteUserSavedFilterPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteUserSavedFilterMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteUserSavedFilterMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteUserSavedFilterMutation",
    "id": null,
    "text": "mutation DeleteUserSavedFilterMutation(\n  $input: DeleteUserSavedFilterInput!\n) {\n  deleteUserSavedFilter(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f532fed3820f1bc1251213aab0246aa9';
module.exports = node;
